import {VetologyBase} from "../Vetology/VetologyBase";

export class ClinicManager extends VetologyBase
{
    constructor()
    {
        super('ClinicManager');
    }

    init()
    {
	    const _self = this;
	    if (!document.querySelector('form.clinic-manager')) {
		    return;
	    }

	    const clinicIdInput = document.querySelector('input[name="cid"]');
	    const clinicID = clinicIdInput.value;
	    const queryString = new URLSearchParams();
	    queryString.append('clinicID', clinicID);
	    fetch('/clinic/manage/get-custom-logo-info?' + queryString.toString(),
		    {
			    method: 'get',
			    accept: 'json'
		    }).then((response) => {
		    if (response.ok) {
			    response.json().then(data => {
				    if (data.success) {
					    const imageHandler = document.querySelector('div.imageHandler');
					    const html = data.html;

					    const customLogoMarkup = document.querySelector(".custom-logo-markup");
					    _self.placeMarkupBeforeImage(customLogoMarkup);
				    }
			    });
		    }
	    });
    }

    placeMarkupBeforeImage(markupElement)
    {
        const logoElem = document.querySelector("img.img_GooglePlaceIDLogo");
        logoElem.parentElement.insertBefore(markupElement, logoElem);
    }

}

